module.exports = {"title":"David Luecke","talk":"Meet MySam - An open AI experiment","path":"/speakers/david-luecke","type":"speaker","slug":"david-luecke","twitter":"daffl","github":"daffl","body":"<p>Apple has Siri, Google has Google Now, Facebook has M. Why can't we have our <strong>own</strong> virtual assistant?</p>\n<p>In this talk I'd like you to meet MySam, an open-source \"intelligent\" assistant that you can train yourself and extend with plugins written in JavaScript and HTML5.</p>"}


/*****************
 ** WEBPACK FOOTER
 ** ./speakers/david-luecke.md
 ** module id = 496
 ** module chunks = 0
 **/